// extracted by mini-css-extract-plugin
export var description = "TechnologyCard-module--description--wmNFA";
export var headerSection = "TechnologyCard-module--headerSection--GMjL1";
export var stepOverviewSection = "TechnologyCard-module--stepOverviewSection--zLi1Y";
export var stepOverviewTitle = "TechnologyCard-module--stepOverviewTitle--Dp5zN";
export var subtitle = "TechnologyCard-module--subtitle--12Xyb";
export var technologyCardWrapper = "TechnologyCard-module--technologyCardWrapper--JnA1L";
export var title = "TechnologyCard-module--title--ZWreR";